export default "__VITE_ASSET__Cb0lS88r__"